export const shouldRenderMobileFooter = (): boolean => true;
